<button class="app-button" (click)="handleClick()" pButton [severity]="status" [disabled]="disabled">
  <div *ngIf="isProcessing" style="padding-right: 5px; width: 20px">
    <i  class="fas fa-spinner fa-spinner-small fa-spin" style="color:#000;"></i>
  </div>

  <ng-content></ng-content>
</button>
